import {
  assignInlineVars
} from "./chunk-2YDJLCMM.mjs";
import {
  Spinner
} from "./chunk-JYYKO2MH.mjs";
import {
  require_classnames
} from "./chunk-PXJBVWC7.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues,
  __toESM
} from "./chunk-WI73T6NA.mjs";

// src/button/button.tsx
var import_classnames = __toESM(require_classnames());
import { forwardRef } from "react";

// src/button/button.css.ts
var buttonStyle = "button_buttonStyle__ek10cy2";
var buttonWidth = "var(--buttonWidth__ek10cy0)";
var sizeStyles = { sm: "button_sizeStyles_sm__ek10cyg button_buttonStyle__ek10cy2", md: "button_sizeStyles_md__ek10cyh button_buttonStyle__ek10cy2", lg: "button_sizeStyles_lg__ek10cyi button_buttonStyle__ek10cy2" };
var spinnerStyle = "button_spinnerStyle__ek10cy1";
var variants = { "primary-blue": "button_variants_primary-blue__ek10cy3", "primary-red": "button_variants_primary-red__ek10cy4", "secondary-blue": "button_variants_secondary-blue__ek10cy5", copy: "button_variants_copy__ek10cy6", "secondary-red": "button_variants_secondary-red__ek10cy7", "link-primary-blue": "button_variants_link-primary-blue__ek10cy8", "link-primary-red": "button_variants_link-primary-red__ek10cy9", "link-primary-warning": "button_variants_link-primary-warning__ek10cya", toggle: "button_variants_toggle__ek10cyb", "default-green": "button_variants_default-green__ek10cyc", transparent: "button_variants_transparent__ek10cyd", none: "button_variants_none__ek10cye", "default": "button_variants_default__ek10cyf" };

// src/button/button.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
var Button = forwardRef(
  (props, ref) => {
    const _a = props, {
      children,
      className,
      loading,
      variant,
      size,
      fullWidth = false,
      style
    } = _a, rest = __objRest(_a, [
      "children",
      "className",
      "loading",
      "variant",
      "size",
      "fullWidth",
      "style"
    ]);
    const btnClasses = (0, import_classnames.default)(
      "pq-button",
      className,
      buttonStyle,
      variants[variant],
      size ? sizeStyles[size] : sizeStyles.lg
    );
    return /* @__PURE__ */ jsxs(
      "button",
      __spreadProps(__spreadValues({
        ref,
        className: btnClasses,
        style: __spreadValues(__spreadValues({}, style), assignInlineVars({
          [buttonWidth]: fullWidth ? "100%" : "auto"
        }))
      }, rest), {
        children: [
          children,
          loading && /* @__PURE__ */ jsx(Spinner, { className: spinnerStyle })
        ]
      })
    );
  }
);
Button.displayName = "Button";

export {
  Button
};
//# sourceMappingURL=chunk-BF5QNCEA.mjs.map